import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "./UI_components/Alert";
import { Search, Settings, Bell } from "lucide-react";
import { BASE_URL } from "../utils/constant";
import avatar from "../assets/3d_avatar_26.png";
import sitemasterLogo from "../assets/SiteMaster.svg";
import { FaAngleRight } from "react-icons/fa6";
import { IoSettings } from "react-icons/io5";
import { IoIosChatbubbles, IoIosNotifications } from "react-icons/io";
import ProfileCard from "./ProfileCard";
import importIcon from "../assets/Subtract.svg";
import FileUploadModal from "../screens/Project Dashboard/Report/ExcelFileUpload";
import { set } from "date-fns";
import { FiChevronDown } from "react-icons/fi";
import { ProjectApi } from "api/projects/service";
import TaskChatbot from "./TaskChatbot";
import NotificationSidePopUp from "./NotificationSidePopUp";
import { useNotifications } from "utils/Notifications/NotificationContext";
import { FaStore, FaUserClock } from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { SubscriptionAPI } from "api/dashboard/service";
const TopBar = ({ prepareForLogout, onProfileToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    notifications,
    requestNotificationPermission,
    unreadCount,
    markAllAsRead,
    markAsRead,
  } = useNotifications();
  const [site, setSite] = useState({});
  const [userData, setUserData] = useState({});
  const [showProfile, setShowProfile] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("Home");
  const { addAlert } = useAlert();
  const profileButtonRef = useRef(null);
  const profileCardRef = useRef(null);
  const projectsButtonRef = useRef(null);
  const projectsDropdownRef = useRef(null);
  const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [showTaskChat, setShowTaskChat] = useState(false);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);

  const getCurrentTab = () => {
    const paths = location.pathname.split("/");
    // path will be the 2nd element after "siteId"
    const path = paths[3];
    switch (path) {
      case "home":
        return "Home";
      case "tasks":
        return "Tasks";
      case "finance":
        return "Finance";
      case "materials":
        return "Materials";
      case "workers":
        return "Workers";
      case "details":
        return "Site Details";
      case "snags":
        return "Snags";
      case "report":
        return "Reports";
      case "chats":
        return "Chats";
      case "boq":
        return "BoQ";
      default:
        return "Home";
    }
  };
  useEffect(() => {
    const currentTab = getCurrentTab();
    setCurrentTab(currentTab);
  }, [location.pathname]);

  useEffect(() => {
    const getOrganizationId = () => {
      try {
        return JSON.parse(localStorage.getItem("organization") || "{}")?.id;
      } catch {
        return null;
      }
    };

    let isMounted = true;
    const fetchSubscription = async () => {
      const organizationId = getOrganizationId();
      if (!organizationId) {
        if (isMounted) setHasActiveSubscription(false);
        localStorage.setItem("hasActiveSubscription", "false");
        return;
      }

      try {
        const response =
          await SubscriptionAPI.checkUserSubscription(organizationId);
        const isActive =
          response?.status &&
          response?.data?.active_flag &&
          (!response?.data?.valid_till ||
            response.data.valid_till > new Date().toISOString());

        if (isMounted) setHasActiveSubscription(Boolean(isActive));
        localStorage.setItem(
          "hasActiveSubscription",
          isActive ? "true" : "false",
        );
      } catch {
        if (isMounted) setHasActiveSubscription(false);
        localStorage.setItem("hasActiveSubscription", "false");
      }
    };

    const syncStoredSubscription = () => {
      setHasActiveSubscription(
        localStorage.getItem("hasActiveSubscription") === "true",
      );
    };

    fetchSubscription();
    window.addEventListener("storage", syncStoredSubscription);
    window.addEventListener("organizationChanged", fetchSubscription);
    window.addEventListener("focus", fetchSubscription);

    return () => {
      isMounted = false;
      window.removeEventListener("storage", syncStoredSubscription);
      window.removeEventListener("organizationChanged", fetchSubscription);
      window.removeEventListener("focus", fetchSubscription);
    };
  }, []);

  const toggleNotifications = () => {
    if (!isNotificationOpen) {
      setShowProfile(false);
    }
    setIsNotificationOpen(!isNotificationOpen);
    // Close other dropdowns when opening notifications
  };

  const handleLogout = async () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        refresh: localStorage.getItem("refresh"),
      }),
    };
    try {
      const response = await fetch(
        `${BASE_URL}/token/blacklist/`,
        requestOptions,
      );
      const data = await response.json();
      // console.log(data);
      await prepareForLogout();
      if (data?.code !== "token_not_valid") {
        localStorage.clear();
        navigate("/login");
      } else {
        console.log("Token not valid");
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSite = async () => {
    try {
      const accessToken = localStorage.getItem("access");
      const siteId = localStorage.getItem("site");

      if (accessToken && siteId) {
        const response = await fetch(
          `${BASE_URL}/sites/get-a-sites/${siteId}/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        const data = await response.json();
        if (data.status) {
          setSite(data.data);
        } else {
          throw new Error(data.message);
        }
      }
    } catch (error) {
      // alert.error(error.message);
    }
  };

  const getUserData = async () => {
    try {
      const accessToken = localStorage.getItem("access");

      if (accessToken) {
        const response = await fetch(`${BASE_URL}/auth/user-details-of-user/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (!response.ok) {
          // navigate("/profession");
          return;
        }
        const data = await response.json();
        if (data?.status) {
          setUserData(data?.data);
        } else {
          // navigate("/profession");
          throw new Error(data?.message);
        }
      }
    } catch (error) {
      // alert.error(error?.message);
      addAlert("Failed to get user details", "error");
    }
  };

  // Fetch active projects similar to MyProjects.js (only those user can access)
  const fetchSitesWithMembers = async (organizationId) => {
    let userLocal = null;
    try {
      userLocal = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      userLocal = null;
    }

    let sites = [];
    if (userLocal?.profession === "owner") {
      sites = await ProjectApi.listSitesByOrganization(organizationId);
    } else {
      const response = await ProjectApi.listSitesByUser();
      sites = (response?.data || []).filter(
        (site) => site.organization === organizationId,
      );
    }
    if (!sites || sites.length === 0) return [];
    return sites;
  };

  useEffect(() => {
    getUserData();
    getSite();
  }, [
    localStorage.getItem("site"),
    localStorage.getItem("siteData"),
    localStorage.getItem("access"),
  ]);

  useEffect(() => {
    const handleUserProfileUpdated = (event) => {
      const updatedUser = event?.detail;
      if (updatedUser && typeof updatedUser === "object") {
        setUserData(updatedUser);
      } else {
        getUserData();
      }
    };

    window.addEventListener("userProfileUpdated", handleUserProfileUpdated);
    return () => {
      window.removeEventListener("userProfileUpdated", handleUserProfileUpdated);
    };
  }, []);

  // Load projects for dropdown
  useEffect(() => {
    const organization_id = JSON.parse(
      localStorage.getItem("organization"),
    )?.id;
    if (!organization_id) return;
    let isMounted = true;
    setLoadingProjects(true);
    fetchSitesWithMembers(organization_id)
      .then((data) => {
        if (isMounted) setProjects(data || []);
      })
      .finally(() => {
        if (isMounted) setLoadingProjects(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  // Close profile card on outside click
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (!showProfile) return;
  //     const clickedInsideCard = profileCardRef.current?.contains(event.target);
  //     const clickedOnButton = profileButtonRef.current?.contains(event.target);
  //     if (!clickedInsideCard && !clickedOnButton) {
  //       setShowProfile(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, [showProfile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!showProfile) return;
      const clickedInsideCard = profileCardRef.current?.contains(event.target);
      const clickedOnButton = profileButtonRef.current?.contains(event.target);
      if (!clickedInsideCard && !clickedOnButton) {
        setShowProfile(false);

        // Notify parent when closing profile
        if (onProfileToggle) {
          onProfileToggle(false);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showProfile, onProfileToggle]);

  // Close projects dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!showProjectsDropdown) return;
      const clickedInsideDropdown = projectsDropdownRef.current?.contains(
        event.target,
      );
      const clickedOnButton = projectsButtonRef.current?.contains(event.target);
      if (!clickedInsideDropdown && !clickedOnButton) {
        setShowProjectsDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showProjectsDropdown]);

  return (
    <header className="bg-sm-background sticky top-0 z-20">
      <div className="max-w-full mx-auto">
        <div className="flex items-center justify-between h-16 px-3">
          {/* empty left for now */}
          {/* <div className="flex items-center gap-2"></div> */}
          {/* Left section */}
          <div className="flex items-center gap-2">
            <div className="flex flex-row px-1.5 py-1 items-center hover:bg-gray-100 rounded-lg max-w-[210px]">
              {site?.image_file ? (
                <img
                  src={site?.image_file}
                  alt="Site logo"
                  className="h-8 w-8 rounded-full border border-gray-200 object-cover flex-shrink-0"
                />
              ) : (
                <div className="h-8 w-8 rounded-full  bg-sm-primary flex items-center justify-center">
                  {/* project name initials */}
                  {site?.site_name && (
                    <p className="text-white text-[14px] font-semibold">
                      {site?.site_name?.charAt(0)?.toUpperCase() +
                        site?.site_name?.charAt(1)?.toUpperCase()}
                    </p>
                  )}
                </div>
              )}
              <div className="flex flex-col ml-2 items-start w-[80%] justify-start cursor-pointer">
                <div className="flex flex-row items-center w-full justify-between">
                  <p
                    className="text-[#343C6A] text-[16px] font-bold hover:underline truncate "
                    onClick={() => {
                      navigate(`/site/${site?.id}/details`);
                    }}
                  >
                    {site?.site_name}
                  </p>
                  <div className="relative ml-2">
                    <button
                      ref={projectsButtonRef}
                      onClick={() => setShowProjectsDropdown((p) => !p)}
                      className="flex items-center rounded hover:bg-gray-100"
                    >
                      {/* <span className="text-[12px] text-[#374151] font-medium">Projects</span> */}
                      <FiChevronDown className="h-5 w-5 text-[#8D8D8D]" />
                    </button>
                    {showProjectsDropdown && (
                      <div
                        ref={projectsDropdownRef}
                        className="absolute left-0 mt-3 w-72 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-80 overflow-y-auto"
                        style={{
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                      >
                        {/* <style jsx>{`
                      div::-webkit-scrollbar {
                        display: none;
                      }
                    `}</style> */}

                        {loadingProjects ? (
                          <div className="flex items-center justify-center px-4 py-8">
                            <div className="flex items-center gap-2 text-sm text-gray-500">
                              <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                              Loading projects...
                            </div>
                          </div>
                        ) : (
                          <>
                            {projects.filter((p) => p.active_flag !== false)
                              .length > 0 ? (
                              <div className="py-2">
                                {projects
                                  .filter((p) => p.active_flag !== false)
                                  .map((p, index) => (
                                    <div
                                      key={p.id}
                                      className={`px-4 py-3 hover:bg-gray-100 flex flex-row items-center gap-3 cursor-pointer transition-colors duration-150 ${
                                        index !== 0
                                          ? "border-t border-gray-100"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        localStorage.setItem("site", p.id);
                                        localStorage.setItem(
                                          "siteName",
                                          p.site_name,
                                        );
                                        localStorage.setItem(
                                          "siteData",
                                          JSON.stringify(p),
                                        );
                                        setShowProjectsDropdown(false);
                                        navigate(`/site/${p.id}/`);
                                      }}
                                    >
                                      {p.image_file ? (
                                        <img
                                          src={p.image_file}
                                          alt={`${p.site_name} logo`}
                                          className="h-8 w-8 rounded-full border border-gray-200 object-cover flex-shrink-0"
                                        />
                                      ) : (
                                        <div className="h-8 w-8 rounded-full  bg-sm-primary flex items-center justify-center">
                                          {/* project name initials */}
                                          <p className="text-white text-[14px] font-semibold">
                                            {p.site_name
                                              ?.charAt(0)
                                              .toUpperCase() +
                                              p.site_name
                                                ?.charAt(1)
                                                .toUpperCase()}
                                          </p>
                                        </div>
                                      )}
                                      <div className="flex flex-col items-start w-[80%]">
                                        <div className="text-sm font-semibold text-ellipsis text-gray-900 mb-1 truncate">
                                          {p.site_name}
                                        </div>

                                        <div className="text-xs text-gray-500 flex items-center gap-1">
                                          <svg
                                            className="w-3 h-3"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                          <span className="truncate">
                                            {!p.city && !p.pincode
                                              ? "NA"
                                              : `${p.city}, ${p.pincode}`}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            ) : (
                              <div className="px-4 py-8 text-center">
                                <div className="text-gray-400 mb-2">
                                  <svg
                                    className="w-8 h-8 mx-auto"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1.5}
                                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                    />
                                  </svg>
                                </div>
                                <div className="text-sm font-medium text-gray-500 mb-1">
                                  No active projects
                                </div>
                                <div className="text-xs text-gray-400">
                                  All projects are currently inactive
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {/* <p className="text-[#737373] text-[12px] font-normal">
                  {!site?.city && !site?.pincode
                    ? "Address not set"
                    : `${site.city ? site.city : ""} ${site?.pincode ? `,${site.pincode}` : ""
                    }`}
                </p> */}
              </div>
            </div>
            {/* <div
              className="h-[45px] flex flex-row items-center px-6 py-2 gap-[16px] rounded-[8px] 
              border-[1px] border-[#E5E7EB]"
            >
              {userData?.profession === "owner" ? (
                <>
                  <h1
                    className="text-[16px] font-medium text-[#374151] hover:underline cursor-pointer"
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Global Dashboard
                  </h1>
                  <FaAngleRight />
                  <h1
                    className="text-[16px] font-medium text-[#374151] hover:underline cursor-pointer"
                    onClick={() => {
                      navigate(`/dashboard/projects`);
                    }}
                  >
                    All Projects
                  </h1>
                  <FaAngleRight />
                  <h1 className="text-[16px] font-medium text-[#374151] hover:underline cursor-pointer">
                    {currentTab}
                  </h1>
                </>
              ) : (
                <>
                  <h1
                    className="text-[16px] font-medium text-[#374151] hover:underline cursor-pointer"
                    onClick={() => {
                      navigate(`/dashboard/projects`);
                    }}
                  >
                    All Projects
                  </h1>
                  <FaAngleRight />
                  <h1 className="text-[16px] font-medium text-[#374151]">
                    Home
                  </h1>
                </>
              )}
            </div> */}
          </div>

          {/* Right section */}
          <div className="flex items-center gap-2">
            <div className="flex-1 mx-2">
              <div className="relative">
                {/* <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Search className="h-4 w-4 text-[#7A6E82]" />
                </div> */}
                {/* <input
                  type="text"
                  placeholder="Search for something"
                  className="pl-10 pr-4 py-2 bg-[#F3F0F5] rounded-3xl text-sm text-[#877A90] focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent transition-all"
                /> */}
              </div>
            </div>
            {/* Task updates chatbot */}
            {/* <div className="relative">
              <button
                className="bg-[#ECE6F0] rounded-lg p-2 transition-colors hover:bg-[#D9D0E6]"
                onClick={() => setShowTaskChat(true)}
                title="Ask about task updates"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="#58267F"
                  className="h-5 w-5"
                >
                  <path d="M12 2a7 7 0 00-7 7v2.268A2 2 0 004 13v2a2 2 0 002 2h1v3l3-3h2l3 3v-3h1a2 2 0 002-2v-2a2 2 0 00-1-1.732V9a7 7 0 00-7-7z" />
                </svg>
              </button>
              <TaskChatbot isOpen={showTaskChat} onClose={() => setShowTaskChat(false)} />
            </div> */}
            {/* <button
              className="bg-[#ECE6F0] rounded-lg p-2 transition-colors"
              onClick={() => {
                setShowUploadModal(true);
              }}
            >
              <img src={importIcon} alt="import" className="h-5 w-5" />
            </button> */}

            <div className="flex items-center">
              {userData.profession === "owner" && (
                <div className="relative mr-4">
                  <button
                    className="bg-[#ECE6F0] rounded-lg p-2 transition-colors hover:bg-[#D9D0E6]"
                    onClick={() => {
                      navigate("/dashboard/actions");
                    }}
                  >
                    <FaUserClock fill="#58267F" className="h-5 w-5" />
                  </button>
                </div>
              )}
              <div className="relative mr-4">
                <button
                  type="button"
                  disabled={!hasActiveSubscription}
                  title={
                    hasActiveSubscription
                      ? "Open global chat"
                      : "Subscription required for global chat"
                  }
                  className={`bg-[#ECE6F0] rounded-lg p-2 transition-colors ${
                    hasActiveSubscription
                      ? "hover:bg-[#D9D0E6]"
                      : "cursor-not-allowed opacity-50"
                  }`}
                  onClick={() => {
                    if (!hasActiveSubscription) return;
                    navigate("/dashboard/global-communication/general-updates");
                  }}
                >
                  <IoIosChatbubbles fill="#58267F" className="h-5 w-5" />
                </button>
              </div>
              <div className="relative mr-4">
                <button
                  className="bg-[#ECE6F0] rounded-lg p-2 transition-colors hover:bg-[#D9D0E6]"
                  onClick={toggleNotifications}
                >
                  <IoIosNotifications fill="#58267F" className="h-5 w-5" />
                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {unreadCount > 99 ? "99+" : unreadCount}
                    </span>
                  )}
                </button>
                <NotificationSidePopUp
                  isOpen={isNotificationOpen}
                  onClose={() => setIsNotificationOpen(false)}
                  notifications={notifications}
                  markAllAsRead={markAllAsRead}
                  markAsRead={markAsRead}
                  currentUser={userData}
                />
              </div>

              <button
                onClick={() => {
                  const newState = !showProfile;
                  setShowProfile(newState);

                  // Notify parent component
                  if (onProfileToggle) {
                    onProfileToggle(newState);
                  }
                }}
                ref={profileButtonRef}
                className="flex items-center p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
              >
                {userData?.userpic ? (
                  <img
                    src={userData?.userpic}
                    alt="Profile"
                    style={{
                      objectFit: "cover",
                    }}
                    className="h-8 w-8 rounded-full ring-2 ring-gray-100"
                  />
                ) : (
                  // avatar with initials
                  <div className="p-1 w-8 h-8 rounded-full bg-sm-primary flex items-center justify-center">
                    <span className="text-md font-medium text-white">
                      {userData?.first_name?.charAt(0)}
                      {userData?.last_name?.charAt(0)}
                    </span>
                  </div>
                )}
              </button>
              {showProfile && (
                <div
                  className="absolute right-0 mt-5 w-48"
                  ref={profileCardRef}
                >
                  <ProfileCard
                    handleLogOut={handleLogout}
                    data={userData}
                    onClose={() => setShowProfile(false)}
                  />
                </div>
              )}
              {showUploadModal && (
                <FileUploadModal onClose={() => setShowUploadModal(false)} />
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;